/**
 * Extracts the translation values for the transform string used by reakit
 * to position the popover and popover arrow
 */
export const extractTranslationValues = (transform) => {
    var _a;
    const translationValuesAsRegMatch = transform === null || transform === void 0 ? void 0 : transform.match(/translate[a-zA-Z0-9]{0,2}\(([^)]+)\)/);
    const translationValuesAsArray = translationValuesAsRegMatch
        ? (_a = translationValuesAsRegMatch[1]) === null || _a === void 0 ? void 0 : _a.split(',').map((x) => parseFloat(x.trim().replace('px', '')))
        : [0, 0];
    return translationValuesAsArray
        ? [translationValuesAsArray[0], translationValuesAsArray[1]]
        : [0, 0];
};
/**
 * 'left' and 'right' are 'stage left' and 'stage right'. In other words,
 * relative to the body of the popover.
 * 'left' and 'right' describe the direction the diagonal in the triangle is facing
 */
export const calculateArrowOrientation = (placement, popoverWidth, popoverHeight, arrowTranslation) => {
    if (placement === 'top' || placement === 'bottom') {
        const isArrowInLeftHalfOfPopover = arrowTranslation[0] < popoverWidth / 2;
        if (placement === 'top') {
            return isArrowInLeftHalfOfPopover ? 'left' : 'right';
        }
        return isArrowInLeftHalfOfPopover ? 'right' : 'left';
    }
    const isArrowInTopHalfOfPopover = arrowTranslation[1] < popoverHeight / 2;
    if (placement === 'left')
        return isArrowInTopHalfOfPopover ? 'right' : 'left';
    return isArrowInTopHalfOfPopover ? 'left' : 'right';
};
//# sourceMappingURL=utils.js.map